/* eslint-disable @typescript-eslint/no-explicit-any */
import axios from 'axios';
import { bridgeFetch } from './bridge';
import { emitCustom, emitLog } from './slardar';
import { querystring, querystringify, isDev, isInApp } from './utils';
export interface Response<T> {
  status_code: number;
  err_no: number;
  err_tips: string;
  data: T;
}
type Method = 'GET' | 'POST' | undefined;
interface FetchOptions {
  url: string;
  params?: any;
  method?: Extract<Method, 'GET' | 'POST'>;
  header?: {};
}
export default function request<T>(options: FetchOptions, useBridge = true): Promise<Response<T>> {
  let {
    url
  } = options;
  const {
    params = {}
  } = options;
  const startTime = Date.now();
  let apiCode = 0;

  if (!/^https?:\/\//.test(url)) {
    const host_name = isDev() ? window.location.origin : 'https://api-h2.tiktokv.com';
    url = host_name + url;
  }

  let retPromise: Promise<any>;

  if (isInApp() && useBridge) {
    retPromise = bridgeFetch({ ...options,
      url,
      params,
      header: {
        'Content-Type': 'application/json'
      }
    });
  } else {
    if (isDev()) {
      const __url = new URL(url);

      const {
        origin,
        pathname,
        search
      } = __url;
      const query = { ...querystring(location.search),
        ...querystring(search)
      };
      url = `${origin}${pathname}?${querystringify(query)}`;
    }

    if (options.method === undefined || /^get$/i.test(options.method)) {
      retPromise = axios(url, options);
    } else {
      retPromise = axios(url, {
        data: params,
        ...options
      });
    }

    retPromise = retPromise.then(res => res.data);
  }

  const apiName = new URL(url).pathname;
  retPromise.then(res => {
    emitLog(JSON.stringify(res), 'debug', {
      apiName
    });

    if (res?.status_code) {
      apiCode = res.status_code;
    }

    if (res?.err_no) {
      apiCode = res.err_no;
    }

    return res;
  }).catch(err => {
    // bridge can not throw http_code err
    apiCode = -1;
    throw err;
  }).finally(() => {
    const apiName = new URL(url).pathname;
    emitCustom('referral_api', {
      rt: Date.now() - startTime
    }, {
      apiCode: apiCode.toString(),
      apiName: apiName
    });
  });
  return (retPromise as any);
}
export function get<T>(url: string, options?: Partial<FetchOptions>): Promise<Response<T>> {
  return request({
    method: 'GET',
    url,
    ...options
  });
}
export function post<T>(url: string, options?: Partial<FetchOptions>): Promise<Response<T>> {
  return request({
    method: 'POST',
    url,
    ...options
  });
}
export function ferryFetch(url: string, init?: RequestInit) {
  const method = (init?.method || 'GET' as Extract<Method, 'GET' | 'POST'>);

  if (init?.body) {
    const params = typeof init?.body === 'string' ? JSON.parse(init?.body) : {};
    return request({
      method,
      url,
      params
    });
  }

  return request({
    method,
    url
  });
}
export function axiosFetch(url: string, init?: RequestInit) {
  const method = (init?.method || 'GET' as Extract<Method, 'GET' | 'POST'>);

  if (init?.body) {
    const params = typeof init?.body === 'string' ? JSON.parse(init?.body) : {};
    return request({
      method,
      url,
      params
    }, false);
  }

  return request({
    method,
    url
  }, false);
}